import { AxiosError } from 'axios'
import { toast } from '@/lib/hooks/useToast.ts'
import i18n from '@/i18n.ts'
import { redirect } from 'react-router-dom'

const isOfflineError = (error: AxiosError): boolean =>
  !navigator.onLine || error.code === 'ERR_NETWORK' || error.message === 'Network Error'

export default function handleApiErr(err: unknown, rethrow = true): never | null | Response {
  if (err instanceof AxiosError) {
    if (!isOfflineError(err)) {
      toast({
        variant: 'destructive',
        title: i18n.t('common.error'),
        description: err?.response?.data?.detail,
      })
    }
    if (err?.status === 404 || err?.status === 403) {
      return redirect('/not-found')
    }

    // if (err?.status === 403) {
    //   console.log(`should redirect to /settings/organization/projects`)
    //   return null
    //   return redirect('/settings/organization/projects')
    // }
    if (!rethrow) return null
    throw err
  }
  if (!rethrow) return null

  throw err
}
